import React from 'react';
import { Slot } from 'react-page-layout';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import mapFacets from 'util/react/facet';

export default function Blank({ facet }) {
    const facetClasses = mapFacets(facet, 'layout');
    return (
        <Slot className={classnames('layout', 'layout__blank', facetClasses)} name="content"/>
    );
}

Blank.propTypes = {
    facet: PropTypes.any,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/layouts/blank.js